import LoginPage from 'pages/LoginPage';
import { Navigate } from 'react-router-dom';
import { validateAuthCookie } from 'utils/functions/authentication';

const LoginRoute = () => {
  const isUserAuthenticated = validateAuthCookie();

  return isUserAuthenticated ? <Navigate to="/" /> : <LoginPage />;
};

export default LoginRoute;
